// modules
import { createAction } from 'redux-actions'

export const setTimerAddActivityBillingCodeList = createAction(
  'SET_TIMER_ADD_ACTIVITY_BILLING_CODE_LIST'
)
export const setHeaderAddActivityBillingCodeList = createAction(
  'SET_HEADER_ADD_ACTIVITY_BILLING_CODE_LIST'
)
export const setPatientAddActivityBillingCodeList = createAction(
  'SET_PATIENT_ADD_ACTIVITY_BILLING_CODE_LIST'
)

export const setMinimizedModals = createAction('SET_MINIMIZED_MODALS')
export const removeMinimizedModal = createAction('REMOVE_MINIMIZED_MODAL')

export const setCommonAgencyCaseManagers = createAction(
  'SET_COMMON_AGENCY_CASE_MANAGERS'
)

export const setMedicalDeviceTypes = createAction('SET_MEDICAL_DEVICE_TYPES')
export const setAddActivityFromPatientPage = createAction(
  'SET_ADD_ACTIVITY_FROM_PATIENT_PAGE'
)

export const setUrgentCareOutcomeModalVisible = createAction(
  'SET_URGENT_CARE_OUTCOME_MODAL_VISIBLE'
)
export const setUrgentCareCallUuid = createAction('SET_URGENT_CARE_CALL_UUID')
export const setUrgentCareOutcomeModalInitialValue = createAction(
  'SET_URGENT_CARE_OUTCOME_MODAL_INITIAL_VALUE'
)
export const setUrgentCareOutcomeModalSaved = createAction(
  'SET_URGENT_CARE_OUTCOME_MODAL_SAVED'
)

export const setTranscriptionModalVisible = createAction(
  'SET_TRANSCRIPTION_MODAL_VISIBLE'
)
export const setTranscriptionModalInitialValue = createAction(
  'SET_TRANSCRIPTION_MODAL_INITIAL_VALUE'
)
export const setTranscriptionModalSaved = createAction(
  'SET_TRANSCRIPTION_MODAL_SAVED'
)
export const setTranscriptionModalData = createAction(
  'SET_TRANSCRIPTION_MODAL_DATA'
)
export const setTranscriptionModalLoading = createAction(
  'SET_TRANSCRIPTION_MODAL_LOADING'
)

export const setTelemedicineOutcomeModalInitialValue = createAction(
  'SET_TELEMEDICINE_OUTCOME_MODAL_INITIAL_VALUE'
)

export const setCareTeams = createAction('SET_CARE_TEAMS')

export const setActivityModalOpen = createAction('SET_ACTIVITY_MODAL_OPEN')
export const setActivityClinicalEventsModalOpen = createAction(
  'SET_ACTIVITY_CLINICAL_EVENTS_MODAL_OPEN'
)
export const setActivityClinicalEventsModalPatient = createAction(
  'SET_ACTIVITY_CLINICAL_EVENTS_MODAL_OPEN_PATIENT'
)
export const setActivityModalInitialValues = createAction(
  'SET_ACTIVITY_MODAL_INITIAL_VALUES'
)
export const setActivityModalIsSuccessed = createAction(
  'SET_ACTIVITY_MODAL_IS_SUCCESSED'
)

export const setActivityTimerModalOpen = createAction(
  'SET_ACTIVITY_TIMER_MODAL_OPEN'
)
export const setActivityTimerModalInitialValues = createAction(
  'SET_ACTIVITY_TIMER_MODAL_INITIAL_VALUES'
)
export const setActivityTimerModalIsSuccessed = createAction(
  'SET_ACTIVITY_TIMER_MODAL_IS_SUCCESSED'
)
export const setActivityTimerRecording = createAction(
  'SET_ACTIVITY_TIMER_RECORDING'
)

export const setActivityTimerExtra = createAction('SET_ACTIVITY_TIMER_EXTRA')

export const setPatientCaseManagers = createAction('SET_PATIENT_CASE_MANAGERS')

export const setActionCounter = createAction('SET_ACTION_COUNTER')

export const toggleReferenceTableShowInactive = createAction(
  'TOGGLE_REFERENCE_TABLE_SHOW_INACTIVE'
)
